import { useEffect, useState } from 'react';

import { Image } from 'expo-image';
import { StyleSheet, View } from 'react-native';

import { maybePlayAudioOnce } from './play-audio-once';
import { useAppTakeoverMenuSection } from './use-app-takeover';

export const AppTakeoverMenuSectionTransition = ({ sectionId }: { sectionId: string }) => {
  const {
    isTakeoverActive,
    transitionPicture,
    transitionAudio,
    transitionPictureTime,
  } = useAppTakeoverMenuSection(sectionId);
  const [transitionHidden, setTransitionHidden] = useState(false);

  useEffect(() => {
    if (!isTakeoverActive) {
      return;
    }
    maybePlayAudioOnce(transitionAudio);
    const timeout = setTimeout(() => {
      // remove when its done playing to prevent potential issues. (pointer events can get through still though...)
      setTransitionHidden(true);
    }, transitionPictureTime || 5000);
    return () => clearTimeout(timeout);
  }, [isTakeoverActive, transitionAudio, transitionPictureTime]);

  if (!isTakeoverActive || transitionHidden) {
    return null;
  }

  return (
    <View style={styles.container} pointerEvents="box-none">
      <Image source={transitionPicture} style={styles.image} pointerEvents="box-none" />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    zIndex: 9999,
  },
  image: {
    width: '100%',
    height: '100%',
  },
});
